module.exports = function authorize(roles = []) {
    return (req, res, next) => {
        if (!req.user || !req.user.role || !roles.includes(req.user.role)) {
            if (res.json) return res.json({ error: 'Forbidden: Insufficient role privileges' }, 403);
            res.writeHead(403, { 'Content-Type': 'application/json' });
            return res.end(JSON.stringify({ error: 'Forbidden: Insufficient role privileges' }));
        }
        next();
    };
};
